module.exports = __webpack_public_path__ + "static/media/rg-back.42a332d1.jpg";